import React, { useMemo } from 'react';
import './css/index.scss';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import classNames from 'classnames';
import moment from 'moment';
import styles from './css/index.module.scss';
import TableCell from '../../../../components/TableCell';
import DotsIcon from '../../../../assets/formIcons/dots.svg';
import BlockIcon from '../../../../assets/formIcons/block.svg';
import RefreshIcon from '../../../../assets/formIcons/refresh.svg';
import ChangeUserIcon from '../../../../assets/formIcons/changeUser.svg';
import DeleteIcon from '../../../../assets/formIcons/delete.svg';
import ChangeOrgIcon from '../../../../assets/formIcons/changeOrg.svg';
import ChangePhotosIcon from '../../../../assets/formIcons/photosSmall.svg';
import TableRow from '../../../../components/TableRow';
import useComponentVisible from '../../../../helpers/hooks/useComponentVisible';
import { EVENT_MODAL_STATES } from '../../constants';
import Api from '../../../../Api';

function EventItem({
  item, itemsPassed, widths, index, setSelectedEvent, setModalState, setIsModalVisible,
}) {
  const navigate = useNavigate();
  const { profile } = useSelector((store) => store.account);
  const { ref, isComponentVisible, setIsComponentVisible } = useComponentVisible(false);

  const shouldShowDots = useMemo(() => profile?.can_edit_events || profile?.can_fully_delete, [profile, item.creator_admin]);

  const onEventClick = (el) => {
    // navigate(`/events/single-view?id=${el._id}`);
    window.open(`/events/single-view?id=${el._id}`, '_blank');
  };

  const onPopupItemClick = (state) => (ev) => {
    ev.stopPropagation();
    setSelectedEvent(item);
    setModalState(state);
    setIsModalVisible(true);
    setIsComponentVisible(false);
  };

  const onEditClick = (el) => (ev) => {
    ev.stopPropagation();
    // navigate(`/events/edit?id=${el._id}`);
    window.open(`/events/edit?id=${el._id}`, '_blank');
  };

  const onEditPhotosClick = (el) => (ev) => {
    ev.stopPropagation();
    // navigate(`/events/edit-photos?id=${el._id}`);
    window.open(`/events/edit-photos?id=${el._id}`, '_blank');
  };

  return (
    <div
      // onClick={() => onOrgClick(item)}
      className={classNames(styles.item, { [styles.dashed]: !item.is_active })}
      key={item._id}
    >
      <div className={styles.top}>
        <div className={styles.topLeft} onClick={() => onEventClick(item)}>
          <img className={styles.photo} src={Api.url + item.carousel_photos[0]?.preview_url} alt="Photo" />
        </div>
        <div className={styles.topMiddle}>
          <p className={styles.title}>{item.name}</p>
          <div>
            <p className={styles.text}>{item.country.name}</p>
            <div style={{ height: '10px' }} />
            <p className={styles.textGrey}>{item.city.name}</p>
          </div>
        </div>
        <div className={styles.topRight}>
          {shouldShowDots ? (
            <TableCell
              isIcon
              onClick={(ev) => {
                ev.stopPropagation();
                setIsComponentVisible(true);
              }}
            >
              <img src={DotsIcon} alt=":" />
            </TableCell>
          ) : <div />}
          <p className={styles.text}>{moment(item.createdAt).format('DD/MM/YYYY')}</p>
          <p className={styles.textGrey}>
            ID EVENT:
            {' '}
            {item._id}
          </p>
        </div>
      </div>

      <div className={styles.bottom}>
        <div className={styles.bottomLeft}>
          {/* <p className={styles.text}>{item.category.name}</p> */}
          {/* <p className={styles.text}>{item.sub_categories.map((i) => i.name).join(', ')}</p> */}
          <p className={styles.text}>{item.holding_date}</p>
          <p className={styles.text}>{item.specialization}</p>
        </div>
        <div className={styles.bottomRight}>
          <p className={styles.text}>{item.user.email}</p>
          <p className={styles.text}>{moment(item.user.createdAt).format('DD/MM/YYYY')}</p>
          <p className={styles.textGrey}>
            ID OWN:
            {' '}
            {item.user._id}
          </p>
        </div>
      </div>

      <div ref={ref} className={`table_popup ${isComponentVisible && 'visible'}`}>
        {(profile?.can_edit_events) && (
          <>
            {item.is_active ? (
              <div className="table_popup_item" onClick={onPopupItemClick(EVENT_MODAL_STATES.block)}>
                <img src={BlockIcon} alt="" />
                <p>Забанить мероприятие</p>
              </div>
            ) : (
              <div className="table_popup_item" onClick={onPopupItemClick(EVENT_MODAL_STATES.makeActive)}>
                <img src={RefreshIcon} alt="" />
                <p>Разбанить мероприятие</p>
              </div>
            )}
            <div className="table_popup_item" onClick={onEditClick(item)}>
              <img src={ChangeOrgIcon} alt="" />
              <p>Изменить данные</p>
            </div>
            <div className="table_popup_item" onClick={onEditPhotosClick(item)}>
              <img src={ChangePhotosIcon} alt="" />
              <p>Изменить фото</p>
            </div>
          </>
        )}
        {profile?.can_fully_delete && (
          <div className="table_popup_item" onClick={onPopupItemClick(EVENT_MODAL_STATES.fullyDelete)}>
            <img src={DeleteIcon} alt="" />
            <p>Удалить полностью</p>
          </div>
        )}
      </div>
    </div>
  );
}

export default EventItem;
